/* global localStorage */

import axios from "axios";
import { auth } from "@/api";
import { EventBus } from "@/utils";
// import router from '../router'8 °C	58.8 %	0 W/m2	2 W/m2	1009.21 hPa	20.1 °C	20.1 °C	20.1 °C
/* process.env.API_URL || */

/* process.env.API_URL || */
// const API_URL = 'https://api.twoflower.biz'
const API_URL = "https://poc-gw.corryn.net"; //
// const API_URL="http://fokanetwork.dyndns.info:18082";
// const API_URL="http://localhost:8999";
// const API_URL="http://localhost:8990";

var headers = {};

function tokens() {
  if (localStorage.token && localStorage.token !== "") {
    return localStorage.token;
  } else {
    return "";
  }
}

headers["Content-Type"] = "application/json";
headers["Authorization"] = "Bearer " + tokens();

var server = axios.create({
  baseURL: API_URL,
  headers: headers
});

server.interceptors.request.use(
  function(config) {
    var jwt = localStorage.token;
    if (typeof jwt !== "undefined" && jwt != null && jwt !== "") {
      config.headers.Authorization = "Bearer " + jwt;
    } else {
      config.headers.Authorization = "";
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

server.interceptors.response.use(
  function(response) {
    // intercept the global error
    return response;
  },
  function(error) {
    if (!error.response) {
      EventBus.$emit("notify", {
        type: "error",
        message: `Error occured contacting server. Please. try again later. (${error.message})`
      });
      auth.logout();
      return false;
    } else if (
      error.response.status === 401 &&
      error.response.data === "Unauthorized"
    ) {
      EventBus.$emit("notify", {
        type: "error",
        message: `Unauthorized.`
      });
      auth.logout();
      return false;
    }
    /* let originalRequest = error.config
  if ((error.response.status === 401) && !originalRequest._retry &&
      (error.response.data === 'Unauthorized') && localStorage.refreshToken && (localStorage.refreshToken !== '')) { // if the error is 401 and hasent already been retried
    // 401 Unauthorized
    originalRequest._retry = true // now it can be retried
    let refreshToken = localStorage.refreshToken
    return auth.renew(refreshToken).then((data) => {
      if (data && data.data && data.data.token) {
        EventBus.$emit('Authenticated')
        localStorage.token = data.data.token
        originalRequest.headers['Authorization'] = 'Bearer ' + data.data.token // new header new token
        return server(originalRequest) // retry the request that errored out
      } else {
        auth.logout()
        return false
      }
    }).catch((error) => {
      return error
    })
  } */
    /* if (error.response.status !== 404 && error.response.status !== 500) {
      EventBus.$emit("notify", {
        type: "error",
        message: `Error ${error.response.status}. Logging out.`
      });
      auth.logout();
      return Promise.reject(error);
    } */
    //return Promise.resolve(null);
    return Promise.reject(new Error(error !== null && error !== undefined && error.response !== null && error.response !== undefined ? error.response.data : 'Unknown error'));
  }
);

export default server;
